import { useState } from "react";

import { LivestreamGuessPanel } from "@/pages/home/livestream/LivestreamGuessPanel";
import { homeCommunityInvite } from "@/shared/config/siteContent";
import { useI18n } from "@/shared/i18n/LanguageContext";

export function HomePage() {
  const { copy, language } = useI18n();
  const home = copy.home;
  const [openItems, setOpenItems] = useState<string[]>([]);
  const [qqCopyState, setQqCopyState] = useState<"idle" | "copied">("idle");

  const toggleItem = (title: string) => {
    setOpenItems((current) =>
      current.includes(title)
        ? current.filter((item) => item !== title)
        : [...current, title],
    );
  };

  const copyQqGroupNumber = async () => {
    try {
      await navigator.clipboard.writeText("553248693");
      setQqCopyState("copied");
      window.setTimeout(() => setQqCopyState("idle"), 1400);
    } catch {
      setQqCopyState("idle");
    }
  };

  return (
    <div className="page-stack">
      <section className="hero-grid" id="livestream">
        <article className="hero-copy-panel">
          <div className="home-hero-statement">
            <h1 className="hero-title home-hero-title">{home.hero.title}</h1>
            <p className="home-hero-kicker">{home.hero.statement}</p>
            <p className="home-hero-subtitle">{home.hero.subtitle}</p>
            <ul className="home-hero-pillars" aria-label="Catie human-like behavior">
              {home.hero.pillars.map((pillar) => (
                <li key={pillar}>{pillar}</li>
              ))}
            </ul>
          </div>

          <ul className="hero-faq" aria-label={home.faqLabel}>
            {home.faqItems.map((item) => {
              const isOpen = openItems.includes(item.title);

              return (
                <li
                  key={item.title}
                  className={isOpen ? "hero-faq__item hero-faq__item--open" : "hero-faq__item"}
                >
                  <button
                    className="hero-faq__button"
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => toggleItem(item.title)}
                  >
                    <span className="hero-faq__icon" aria-hidden="true">
                      +
                    </span>
                    <span>{item.title}</span>
                  </button>

                  <div className="hero-faq__content">
                    <div className="hero-faq__content-inner">
                      {item.body.map((paragraph) => (
                        <p key={paragraph}>{paragraph}</p>
                      ))}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>

          {language === "zh" ? (
            <div
              className="home-community-cta home-community-cta--qq"
              role="group"
              aria-label={`${home.community.label}: ${home.community.detail}`}
            >
              <span>{home.community.eyebrow}</span>
              <strong>{home.community.label}</strong>
              <em className="home-community-cta__detail-row">
                <code>{home.community.detail}</code>
                <button type="button" onClick={copyQqGroupNumber}>
                  {qqCopyState === "copied" ? "已复制" : home.community.open}
                </button>
              </em>
            </div>
          ) : (
            <a
              className="home-community-cta"
              href={homeCommunityInvite.href}
              target="_blank"
              rel="noreferrer"
              aria-label={`${home.community.label}: ${home.community.detail}`}
            >
              <span>{home.community.eyebrow}</span>
              <strong>{home.community.label}</strong>
              <em>{home.community.detail}</em>
              <b aria-hidden="true">{home.community.open}</b>
            </a>
          )}
        </article>

        <LivestreamGuessPanel />
      </section>
    </div>
  );
}
